import { render } from "./Posted.vue?vue&type=template&id=4a3ca92a"
import script from "./Posted.vue?vue&type=script&lang=js"
export * from "./Posted.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./Posted.vue?vue&type=style&index=1&id=4a3ca92a&lang=css"

import exportComponent from "/var/www/html/cradle.staging.moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__